// SlidingNFTGrid.js
import React from 'react';
import '../styles/SlidingNFTGrid.css';

const one =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/1.png';
const two =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/2.png';
const three =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/3.png';
const four =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/4.png';
const five =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/5.png';
const six =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/6.png';
const seven =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/7.png';
const eight =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/8.png';
const nine =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/9.png';

const ten =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/10.png';
const eleven =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/11.png';
const twelve =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/12.png';
const thirteen =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/13.png';
const fourteen =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/14.png';
const fifteen =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/15.png';
const sixteen =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/16.png';
const seventeen =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/17.png';
const eighteen =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/18.png';
const nineteen =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/19.png';
const twenty =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/20.png';
const twentyOne =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/21.png';
const twentyTwo =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/22.png';
const twentyThree =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/23.png';
const twentyFour =
    'https://d39nah1etu3fy9.cloudfront.net/images/assets/sealuminati/website-refresh/24.png';

// Original arrays:
const topRowImages = [twentyTwo, two, seven, four, five, three, six, eight];
const middleRowImages = [
    nine,
    ten,
    eleven,
    twelve,
    thirteen,
    fourteen,
    fifteen,
    sixteen,
];
const bottomRowImages = [
    seventeen,
    eighteen,
    twentyThree,
    twenty,
    twentyOne,
    one,
    nineteen,
    twentyFour,
];

// 1) Duplicate each array 4 times to create a longer track.
//    That means we have 4× the original images in each row, for a smoother, longer scroll.
const topRowImagesExtended = [
    ...topRowImages,
    ...topRowImages,
    ...topRowImages,
    ...topRowImages,
    ...topRowImages,
    ...topRowImages,
    ...topRowImages,
];

const middleRowImagesExtended = [
    ...middleRowImages,
    ...middleRowImages,
    ...middleRowImages,
    ...middleRowImages,
    ...middleRowImages,
    ...middleRowImages,
    ...middleRowImages,
];

const bottomRowImagesExtended = [
    ...bottomRowImages,
    ...bottomRowImages,
    ...bottomRowImages,
    ...bottomRowImages,
    ...bottomRowImages,
    ...bottomRowImages,
    ...bottomRowImages,
];

const SlidingNFTGrid = () => {
    return (
        <div className="sliding-nft-grid w-full overflow-hidden my-10">
            {/* Top Row (slides left) */}
            <div className="row-container">
                <div className="slide-track slide-left">
                    {topRowImagesExtended.map((src, i) => (
                        <img
                            key={i}
                            src={src}
                            alt={`Top row ${i}`}
                            className="nft-image"
                        />
                    ))}
                </div>
            </div>

            {/* Middle Row (slides right) */}
            <div className="row-container">
                <div className="slide-track slide-right">
                    {middleRowImagesExtended.map((src, i) => (
                        <img
                            key={i}
                            src={src}
                            alt={`Mid row ${i}`}
                            className="nft-image"
                        />
                    ))}
                </div>
            </div>

            {/* Bottom Row (slides left) */}
            <div className="row-container">
                <div className="slide-track slide-left">
                    {bottomRowImagesExtended.map((src, i) => (
                        <img
                            key={i}
                            src={src}
                            alt={`Bottom row ${i}`}
                            className="nft-image"
                        />
                    ))}
                </div>
            </div>
        </div>
    );
};

export default SlidingNFTGrid;
